var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useState } from 'react';
import { accountApi } from '../../api/common/account';
import { useIsMobile } from '../../hooks';
var hideChallenge = function (challenge) {
    return ((challenge === null || challenge === void 0 ? void 0 : challenge.challengeStatus) === 'INACTIVE' ||
        (challenge === null || challenge === void 0 ? void 0 : challenge.challengeStatus) === 'EXPIRED' ||
        (challenge === null || challenge === void 0 ? void 0 : challenge.activityStatus) === 'REJECTED' ||
        (challenge === null || challenge === void 0 ? void 0 : challenge.activityStatus) === 'COMPLETE' ||
        (challenge === null || challenge === void 0 ? void 0 : challenge.optedStatus) === 'OPTED_OUT');
};
var ChallengesContext = createContext(null);
export var ChallengesProvider = function (_a) {
    var children = _a.children;
    var _b = useState(true), isChallengeLoading = _b[0], setIsChallengeLoading = _b[1];
    var _c = useState(false), hasChallengeError = _c[0], setHasChallengeError = _c[1];
    var _d = useState(false), isAcceptChallengeLoading = _d[0], setIsAcceptChallengeLoading = _d[1];
    var _e = useState(false), showModal = _e[0], setShowModal = _e[1];
    var _f = useState(null), challengesInfo = _f[0], setChallengesInfo = _f[1];
    var _g = useState('NOT_OPTED'), optedStatus = _g[0], setOptedStatus = _g[1];
    var _h = React.useState(false), acceptChallengeError = _h[0], setAcceptChallengeError = _h[1];
    var _j = useState(false), info2Error = _j[0], setInfo2Error = _j[1];
    var _k = useState([]), challenge = _k[0], setChallenge = _k[1];
    var isMobile = useIsMobile().isMobile;
    // Remove duplicate refs - keep only one set
    var hasInitiallyFetched = React.useRef(false);
    var activeRequestRef = React.useRef(null);
    var getChallengesInfo = React.useCallback(function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var force, requestPromise;
        var _a;
        return __generator(this, function (_b) {
            force = (_a = options === null || options === void 0 ? void 0 : options.force) !== null && _a !== void 0 ? _a : false;
            if (activeRequestRef.current && !force) {
                return [2 /*return*/, activeRequestRef.current];
            }
            if (hasInitiallyFetched.current && !force) {
                return [2 /*return*/, Promise.resolve()];
            }
            requestPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, activeChalls, error_1, axiosError, status_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setIsChallengeLoading(true);
                            setHasChallengeError(false);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, accountApi.challengesInfo()];
                        case 2:
                            response = _b.sent();
                            if ((response === null || response === void 0 ? void 0 : response.challenges) && Array.isArray(response.challenges)) {
                                setChallengesInfo(response);
                                activeChalls = response.challenges.filter(function (challenges) { return !hideChallenge(challenges); });
                                setChallenge(activeChalls);
                                hasInitiallyFetched.current = true;
                            }
                            else {
                                // If response is successful but doesn't have expected structure,
                                // treat it as no challenges available (similar to 404)
                                setChallengesInfo({ challenges: [] });
                                setChallenge([]);
                                hasInitiallyFetched.current = true;
                            }
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _b.sent();
                            axiosError = error_1;
                            status_1 = (_a = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _a === void 0 ? void 0 : _a.status;
                            if (status_1 === 404) {
                                // Handle 404 errors gracefully - user might not have any challenges
                                // Set empty challenges but don't mark as error (no error tile should show)
                                setChallengesInfo({ challenges: [] });
                                setChallenge([]);
                                hasInitiallyFetched.current = true;
                            }
                            else if (status_1 && status_1 >= 500 && status_1 < 600) {
                                // Only mark as error for server errors (5xx) - these should show the error tile
                                setHasChallengeError(true);
                            }
                            else {
                                // For other client errors (4xx except 404), also don't show error tile
                                // but don't set challenges either - just let it remain in loading state
                                setChallengesInfo({ challenges: [] });
                                setChallenge([]);
                                hasInitiallyFetched.current = true;
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            setIsChallengeLoading(false);
                            activeRequestRef.current = null;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })();
            activeRequestRef.current = requestPromise;
            return [2 /*return*/, requestPromise];
        });
    }); }, []);
    // Use the correct ref for initial fetch
    React.useEffect(function () {
        if (!hasInitiallyFetched.current && !activeRequestRef.current) {
            getChallengesInfo();
        }
    }, []); // Empty deps - only run once on mount
    var acceptChallenge = React.useCallback(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsAcceptChallengeLoading(true);
                    setAcceptChallengeError(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, accountApi.challengeAccept(payload)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 'SUCCESS' || (response === null || response === void 0 ? void 0 : response.challenges)) {
                        getChallengesInfo({ force: true });
                    }
                    else {
                        throw new Error('Challenge accept API did not return success status');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    setAcceptChallengeError(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsAcceptChallengeLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [getChallengesInfo]);
    var resetAcceptChallengeError = React.useCallback(function () {
        setAcceptChallengeError(false);
    }, []);
    // Remove getChallengesInfo from memoization deps to prevent recreation
    var value = React.useMemo(function () { return ({
        challengesInfo: challengesInfo,
        challenge: challenge,
        isChallengeLoading: isChallengeLoading,
        hasChallengeError: hasChallengeError,
        getChallengesInfo: getChallengesInfo,
        acceptChallenge: acceptChallenge,
        acceptChallengeError: acceptChallengeError,
        isAcceptChallengeLoading: isAcceptChallengeLoading,
        resetAcceptChallengeError: resetAcceptChallengeError,
        info2Error: info2Error,
        hideChallenge: hideChallenge,
    }); }, [
        challengesInfo,
        challenge,
        isChallengeLoading,
        hasChallengeError,
        acceptChallenge,
        acceptChallengeError,
        isAcceptChallengeLoading,
        resetAcceptChallengeError,
        info2Error,
    ]);
    return (React.createElement(ChallengesContext.Provider, { value: value }, children));
};
export { ChallengesContext };
